export default function loadLanguage(language) {
  /* eslint complexity: ["error", {"max": 40}] */
  switch (language) {
    case 'ar':
      return import(/* webpackChunkName: "embed-ar" */ '../lang/ar')
    case 'bg':
      return import(/* webpackChunkName: "embed-bg" */ '../lang/bg')
    case 'cs':
      return import(/* webpackChunkName: "embed-cs" */ '../lang/cs')
    case 'da':
      return import(/* webpackChunkName: "embed-da" */ '../lang/da')
    case 'de':
      return import(/* webpackChunkName: "embed-de" */ '../lang/de')
    case 'en':
      return import(/* webpackChunkName: "embed-en" */ '../lang/en')
    case 'el':
      return import(/* webpackChunkName: "embed-el" */ '../lang/el')
    case 'es':
      return import(/* webpackChunkName: "embed-es" */ '../lang/es')
    case 'et':
      return import(/* webpackChunkName: "embed-et" */ '../lang/et')
    case 'fi':
      return import(/* webpackChunkName: "embed-fi" */ '../lang/fi')
    case 'fr':
      return import(/* webpackChunkName: "embed-fr" */ '../lang/fr')
    case 'hr':
      return import(/* webpackChunkName: "embed-hr" */ '../lang/hr')
    case 'hu':
      return import(/* webpackChunkName: "embed-hu" */ '../lang/hu')
    case 'id':
      return import(/* webpackChunkName: "embed-id" */ '../lang/id')
    case 'is':
      return import(/* webpackChunkName: "embed-is" */ '../lang/is')
    case 'it':
      return import(/* webpackChunkName: "embed-it" */ '../lang/it')
    case 'ja':
      return import(/* webpackChunkName: "embed-ja" */ '../lang/ja')
    case 'ko':
      return import(/* webpackChunkName: "embed-ko" */ '../lang/ko')
    case 'lt':
      return import(/* webpackChunkName: "embed-lt" */ '../lang/lt')
    case 'lv':
      return import(/* webpackChunkName: "embed-lv" */ '../lang/lv')
    case 'ms':
      return import(/* webpackChunkName: "embed-ms" */ '../lang/ms')
    case 'no':
    case 'nb':
      return import(/* webpackChunkName: "embed-nb" */ '../lang/nb')
    case 'nl':
      return import(/* webpackChunkName: "embed-nl" */ '../lang/nl')
    case 'pl':
      return import(/* webpackChunkName: "embed-pl" */ '../lang/pl')
    case 'pt':
      return import(/* webpackChunkName: "embed-pt" */ '../lang/pt')
    case 'ro':
      return import(/* webpackChunkName: "embed-ro" */ '../lang/ro')
    case 'ru':
      return import(/* webpackChunkName: "embed-ru" */ '../lang/ru')
    case 'sk':
      return import(/* webpackChunkName: "embed-sk" */ '../lang/sk')
    case 'sl':
      return import(/* webpackChunkName: "embed-sl" */ '../lang/sl')
    case 'sv':
      return import(/* webpackChunkName: "embed-sv" */ '../lang/sv')
    case 'th':
      return import(/* webpackChunkName: "embed-th" */ '../lang/th')
    case 'tr':
      return import(/* webpackChunkName: "embed-tr" */ '../lang/tr')
    case 'uk':
      return import(/* webpackChunkName: "embed-uk" */ '../lang/uk')
    case 'vi':
      return import(/* webpackChunkName: "embed-vi" */ '../lang/vi')
    case 'zh':
      return import(/* webpackChunkName: "embed-zh" */ '../lang/zh')
    default:
      return import(/* webpackChunkName: "embed-en" */ '../lang/en')
  }
}
